import { useEffect } from 'react';
import { addMilliseconds, isAfter } from 'date-fns';

interface Props {
  enabled: boolean;
  retryTimeMs?: number;
}

const localStorageKey = 'version-refresh';

export const useForcedRefresh = ({ enabled, retryTimeMs = 0 }: Props) => {
  useEffect(() => {
    if (!enabled) return;

    const lastRefreshRaw = localStorage.getItem(localStorageKey);
    const lastRefreshAttempt = lastRefreshRaw
      ? parseInt(lastRefreshRaw, 10)
      : 0;

    if (
      retryTimeMs &&
      !isAfter(
        new Date(),
        addMilliseconds(new Date(lastRefreshAttempt), retryTimeMs),
      )
    ) {
      return;
    }

    localStorage.setItem(localStorageKey, Date.now().toString());
    window.location.reload();
  }, [enabled, retryTimeMs]);
};
